export * from "./components/provider";
export { default as StatsigObserver } from "./components/observer";
export { default as useRoutePathname } from "./hooks/use-route-pathname";
export { default as useExperimentLogger } from "./hooks/use-experiment-logger";
export { useLogEvent } from "./hooks/use-log-event";
export { useScreenViewed } from "./hooks/use-screen-viewed";
export { useOnVisible, isOnScreen } from "./hooks/use-on-visible";
export {
  markPageVisible,
  sendWhenVisible,
  setVisibilityGateOverflowReporter,
  type VisibilityGateOverflow,
} from "./visibility-gate";
export {
  useStatsigUserProperties,
  type StatsigUserCustomProps,
} from "./hooks/use-statsig-user-properties";
export {
  useJourneyId,
  readJourneyId,
  clearJourneyId,
} from "./hooks/use-journey-id";
export {
  useStatsigClient,
  type RegisteredStatsigEvent,
} from "./hooks/use-statsig-client";
export * from "./events";
export { NO_CAPTURE_CLASS } from "./no-capture";
export type { StatsigEvent } from "@statsig/js-client";
export { deriveSurface, type Surface } from "./utils/derive-surface";
export { deriveEntrypointId, type EntrypointId } from "./utils/derive-entrypoint";
export {
  getStripeAttributionMetadata,
  type StripeAttributionInput,
} from "./utils/stripe-attribution";
export {
  warnMissingExternalAccountId,
  type MissingExternalAccountIdWarning,
} from "./warn-missing-external-account-id";

// Validation helpers — exported for use in /api/events ingestion
// (Phase 3 spike) and for advanced consumers. Most callers should not
// need these directly; runtime validation is wired into logStatsigEvent
// and useLogEvent.
export {
  validateEvent,
  EventValidationError,
  type ValidateEventResult,
} from "./events/validate";
